import { Injectable } from '@angular/core';
import * as moment from 'moment';

import { SimpleDate } from '@app/core/models';

@Injectable({ providedIn: 'root' })
export class Clock {

  static getNow(): SimpleDate {
    const now = moment().toObject();
    return {
      year: now.years,
      month: now.months + 1,
      day: now.date,
      hour: now.hours,
      minute: now.minutes,
      second: now.seconds,
      millisecond: now.milliseconds
    };
  }

  now(): SimpleDate {
    return Clock.getNow();
  }
}
